// Calendar dates without a time zone. The form's <input type="date"> speaks 'YYYY-MM-DD'; the
// API stores dates as UTC midnight. Converting through `new Date(...)` in the browser mixes in
// the local zone, so these helpers move between the two shapes with string handling only.

// 'YYYY-MM-DD' from an API value ('2026-07-13T00:00:00.000Z', a Date, or already plain).
export function toPlainDate(value: unknown): string {
  if (!value) return '';
  if (value instanceof Date) return isNaN(value.getTime()) ? '' : value.toISOString().slice(0, 10);
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  return isNaN(d.getTime()) ? '' : d.toISOString().slice(0, 10);
}

// The API timestamp for a plain date: midnight UTC of that calendar day, no local parsing.
export function plainDateToIso(plain: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(plain)) return null;
  return `${plain}T00:00:00.000Z`;
}

// Today as the user sees it on their own calendar (not the UTC date, which lags behind
// Manila by eight hours every evening).
export function todayPlain(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
